<template>
  <div class="redEnvelope_box" v-if="dialogVisible">
    <div class="mask" @click="close"></div>
    <!--bg bg1 -->
    <div class="redEnvelope">
      <!-- 未领取 -->
      <div class="redEnvelope_con" v-if="JSON.parse(reddata.content).receiveStatus === 1">
        <div class="title"><img :src="reddata.avatar" :onerror="errorImg" alt=""> {{ reddata.nickname }}的红包</div>
        <div class="redtitle">{{JSON.parse(reddata.content).Title}}</div>
        <a href="javascript:;" class="btn_open" @click="openred"><img :class="{active: loading}" src="/static/img/red_btn.png" alt=""></a>
      </div>
      <!-- 等待对方领取 -->
      <!-- <div class="redEnvelope_con bg state_one" v-if="step === 1">
        <div class="title"><img src="/static/img/icon_redenvelop.png" :onerror="errorImg" alt=""> 客户经理1的红包</div>
        <div class="redtitle">恭喜发财，大吉大利</div>
        <div class="red_state">红包金额0.01元，等待对方领取</div>
        <div class="red_tip">未领取的红包，将于24小时后发起退款</div>
      </div> -->
      <!-- 已领取 -->
      <div class="redEnvelope_con bg state_two" v-if="JSON.parse(reddata.content).receiveStatus === 2">
        <div class="title"><img :src="reddata.avatar" :onerror="errorImg" alt=""> {{ reddata.nickname }}的红包</div>
        <div class="redtitle">{{JSON.parse(reddata.content).Title}}</div>
        <div class="red_num">{{JSON.parse(reddata.content).amount}}<span>元</span></div>
        <div class="red_info">
          <img :src="tx" :onerror="errorImg" alt="">
          <div class="red_detail">
            <div class="top">
              <div>{{ name }}</div>
              <div>{{JSON.parse(reddata.content).amount}}元</div>
            </div>
            <div class="bot">{{ JSON.parse(reddata.content).receiveTime | timestampToTime }}</div>
          </div>
        </div>
      </div>
      <!-- 已过期 -->
      <div class="redEnvelope_con state_three" v-if="JSON.parse(reddata.content).receiveStatus === 3">
        <div class="title"><img :src="reddata.avatar" alt=""> {{ reddata.nickname }}的红包</div>
        <div class="redtitle">该红包已于 <span>{{ JSON.parse(reddata.content).InvalidTime | timestampToTime }}</span>过期</div>
      </div>
      <div class="btn_close" @click="close"></div>
    </div>
  </div>
</template>

<script>
import {
    mapGetters,
    mapMutations
} from 'vuex'
export default {
  name: "redEnvelope",
  data() {
    return {
      dialogVisible: this.redEnvelopeVisible,
      errorImg: "this.src='/static/img/defaluttx.png'",
      loading: false,
      timer:null
    }
  },
  components: {},
  props: {
    redEnvelopeVisible:{
      type:Boolean,
      required:''
    },
    redEnvelopeData:{
      type: Object,
      defualt: {}
    },
    name:{
      type: String,
      defualt: ''
    },
    tx:{
      type: String,
      defualt: ''
    }
  },
  computed: {
    ...mapGetters('im', [
        'reddata'
    ])
  },
  watch: {
    redEnvelopeVisible() {
      this.dialogVisible = this.redEnvelopeVisible
    }
  },
  mounted() {
    this.SETRED(this.redEnvelopeData)
    console.log(this.redEnvelopeData,'reddata',JSON.parse(this.redEnvelopeData.content))
  },
  methods: {
    ...mapMutations('im', [
        'SETRED'
    ]),
    close(){
      console.log('closered')
      this.$emit('closered')
    },
    openred(){
      this.timer = setTimeout( res => {
        if(JSON.parse(this.reddata.content).receiveStatus === 1) {
          this.$toast('领取超时！')
          this.close()
        }
      },10000)
      this.loading = true
      this.socketApi.sendSock({
          msgType:  'TAKE_MONEY_REQ',
          msgContent:  {
              taskId: this.redEnvelopeData.id,
              weChatId: this.redEnvelopeData.wechatid,
              friendId: this.redEnvelopeData.friendid,
              msgSvrId: this.redEnvelopeData.msgSvrId,
              msgKey: JSON.parse(this.redEnvelopeData.content).Key
          }
      })
    }
  },
  destroy(){
    if(this.timer){
      clearInterval(this.timer)
    }
  }
};
</script>
<style lang="less" scoped>
.redEnvelope_box{
  .mask{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background:rgba(0,0,0,.4);
  }
  .redEnvelope{
    height: 441px;
    width: 300px;
    position: fixed;
    top: 40%;
    left: 50%;
    transform: translate(-50%,-50%);
    border-radius: 8px;
    .btn_close{
      position: absolute;
      bottom: -60px;
      left: 50%;
      transform: translateX(-50%);
      width: 37px;
      height: 37px;
      background: url(/static/img/red_close.png) no-repeat;
      background-size: 100% 100%;
      cursor: pointer;
      z-index: 1;
    }
  }
  .redEnvelope_con {
    height: 441px;
    width: 300px;
    background: url(/static/img/red_bg.png) no-repeat;
    background-size: 100% 100%;
    .title{
      margin: 0 auto;
      text-align: center;
      width: 260px;
      padding-top: 108px;
      line-height: 23px;
      color: #FCE0AA;
      font-size: 14px;
      img{
        width: 23px;
        height: 23px;
        margin-right: 10px;
        vertical-align: middle;
      }
    }
    .redtitle{
      margin: 12px auto 0;
      color: #FCE0AA;
      width: 260px;
      font-size: 20px;
      text-align: center;
      line-height: 30px;
    }
    .btn_open{
      margin: 136px auto 0;
      width: 89px;
      height: 89px;
      display: block;
      position: absolute;
      bottom: 45px;
      left: 50%;
      transform: translateX(-50%);
      img{
        width: 89px;
        height: 89px;
            &.active{
             animation: rotatem 0.5s ease-in-out infinite;
            }
      }
    }
    .red_state, .red_tip{
      margin-top: 40px;
      color: #939CA5;
      padding:0 12px 12px;
      border-bottom: 1px solid #E7E7E7;
    }
    .red_tip{
      margin-top: 170px;
      text-align: center;
      border: none;
    }
  }
  .state_one, .state_two{
    .title{
      font-size: 16px;
      color: #2a2a2a;
      font-weight:500;
      padding-top: 112px;
      img{
        margin-right: 6px;
      }
    }
    .redtitle{
      font-size: 12px;
      color: #939CA5;
      margin-top: 8px;
    }
  }
  .state_two {
    .red_num {
      font-size: 50px;
      font-weight: 600;
      color: #CEAC79;
      text-align: center;
      span{
        display: inline-block;
        font-size: 12px;
        margin-left: 10px;
      }
    }
    .redtitle{
      line-height: 18px;
    }
    .red_info{
      display: flex;
      margin-top: 40px;
      color: #2a2a2a;
      img{
        width: 40px;
        height: 40px;
        margin:0 8px 0 12px;
      }
      .red_detail{
        flex: 1;
        display: flex;
        flex-flow: column;
        padding-right: 12px;
        padding-bottom: 7px;
        border-bottom: 1px solid #E7E7E7;
        .top{
          display: flex;
          justify-content: space-between;
          font-size: 14px;
        }
        .bot{
          font-size: 12px;
          color: #939CA5;
          margin-top: 5px;
        }
      }
    }
  }
  .state_three {
    .redtitle {
      span{
        display: inline-block;
      }
    }
  }
  .bg{
    background:#fff url(/static/img/red_bg1.png) top left no-repeat;
    background-size: 100% 73px;
    border-radius: 8px;
  }
}
@keyframes rotatem {
  from {
    transform: rotateY(0deg)
  }
  to {
    transform: rotateY(-360deg)
  }
}
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/redEnvelope.vue